// extracted by mini-css-extract-plugin
export var items = "menu-sidebar-nav-module--items--ds9F1";
export var languages = "menu-sidebar-nav-module--languages--OimX-";
export var logo = "menu-sidebar-nav-module--logo--WtACT";
export var price = "menu-sidebar-nav-module--price--JzUZ0";
export var ticket = "menu-sidebar-nav-module--ticket--g+fpT";
export var wrapper = "menu-sidebar-nav-module--wrapper--BxDew";